import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectBuilderId } from '../../selectors/builder';
import * as React from 'react';
import { EscrowBlock } from '../../components/EscrowBlock';

export const EscrowBlockContainer = () => {
  const { config } = useApplicationContext();
  const builderId = useSelector(selectBuilderId);

  const escrowBuilders = config.get<number[]>('Countryside.EscrowBuilders');

  if (!escrowBuilders?.includes(builderId)) {
    return null;
  }

  return <EscrowBlock />;
};
